module.exports = __webpack_public_path__ + "img/oman.44246af9.svg";